import i18n from '@src/i18n';

/**
 * Raw API strings that are not valid i18n key segments (spaces, quotes, the
 * USER_NOT_FOUNDED typo) map onto `errors.*` entries copied from v1.
 */
const ERROR_ALIASES: Record<string, string> = {
  USER_NOT_FOUNDED: 'USER_NOT_FOUND',
  '"email" must be a valid email': 'INVALID_EMAIL_FORMAT',
};

const APP_PREFIXES = [
  'notificationAccess.',
  'login.',
  'register.',
  'recover.',
  'otp.',
  'randomizer.',
  'box.',
  'newBox.',
  'upload.',
  'validation.',
  'errors.',
];

/** Turn an API code or app key into an i18n key. Unknown codes become errors.UNKNOWN. */
export function resolveApiErrorKey(message: string): string {
  const trimmed = message.trim();
  if (trimmed.includes('DEACTIVATED_MERGED_USER')) {
    return 'errors.DEACTIVATED_MERGED_USER';
  }
  if (APP_PREFIXES.some((prefix) => trimmed.startsWith(prefix))) {
    return trimmed;
  }
  const code = ERROR_ALIASES[trimmed] ?? trimmed;
  const key = `errors.${code}`;
  return i18n.exists(key) ? key : 'errors.UNKNOWN';
}
